import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PHRTrackerMoodDTO } from '../../../../../generated';
import { IPHRPatientEnhanced } from '../../../../../store/patient/phr/phrReducers';
import { phrMoodsSelector } from '../../../../../store/patient/phr/phrSelectors';
import { getAllForPhrSection } from '../../../../../store/root-creator';
import { ReduxPHRCategoryEnum } from '../../../../../store/types';
import PhrItem, { SecondaryInfoComponent } from '../../../components/PhrItem';
import { getMoodStatusTextByValue } from '../hooks/useTrackers';
import MoodTrackerView from '../MoodTrackerView';
import MoodChart from './MoodChart';
import MoodForm from './MoodForm';

interface IProps {
  patient: IPHRPatientEnhanced;
  renderHeader: (addButton?: any, optionalBack?: any) => any;
  onClose: () => void;
}

const MoodComponent = ({ patient, renderHeader, onClose }: IProps) => {
  const dispatch = useDispatch();
  const moodRecords = phrMoodsSelector(patient.phrMoods);

  useEffect(() => {
    if (patient) {
      dispatch(getAllForPhrSection(ReduxPHRCategoryEnum.PHRMoods, patient.patientID));
    }
  }, [dispatch, patient]);

  const thinView = (mood: PHRTrackerMoodDTO, onView?: (data: any) => void) => (
    <>
      <PhrItem
        name={getMoodStatusTextByValue(mood.moodValue)}
        isVerified={mood.verified}
        onView={() => {
          if (onView) {
            onView(mood);
          }
        }}
        SecondaryInfo={
          <SecondaryInfoComponent
            startDate={mood.trackerDate}
            startDateTitle="Tracked on:"
            showTime
          />
        }
      />
    </>
  );

  return (
    <MoodTrackerView
      renderHeader={renderHeader}
      phrCategoryEnum={ReduxPHRCategoryEnum.PHRMoods}
      patient={patient}
      trackerData={moodRecords}
      thinView={thinView}
      Chart={MoodChart}
      Form={MoodForm}
      createText="Mood"
      onClose={onClose}
    />
  );
};

export default MoodComponent;
